<div class="container alert-modal" *ngIf="componentConfig$ | async as config">
    <div class="row">
        <div class="col-12 alert-head">
            <h3 [innerHtml]="config.title"></h3>
        </div>
        <div class="col-12 alert-body" [innerHtml]="config.content" >
        </div>
        <div class="col-12 alert-footer">
            <serviceos-ng-button (click)="closeModal()" [type]="'secondary'"
                >{{config.close_btn}}</serviceos-ng-button
            >
            <serviceos-ng-button
                (click)="goToRenewMemberShip()"
                [type]="'primary'"
                >{{config.continue_btn}}</serviceos-ng-button
            >
        </div>
    </div>
</div>
